export default __webpack_public_path__ + "content/media/23.857bb39e.jpg";